import { motion, type HTMLMotionProps } from 'motion/react';

import type { ReactNode } from 'react';

interface FadeViewProps extends HTMLMotionProps<'div'> {
  children: ReactNode;
}

export const FadeView = ({ children, ...props }: FadeViewProps) => {
  return (
    <motion.div
      {...props}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.15, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  );
};
